"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var _styled_1 = require("../../styled-components");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  height: 100%;\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  height: 100%;\n"])));
var Dot = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  flex: 0 0 auto;\n  background-color: ", ";\n  margin-top: -8px;\n  border-radius: 50%;\n  ", "\n"], ["\n  display: inline-flex;\n  flex: 0 0 auto;\n  background-color: ", ";\n  margin-top: -8px;\n  border-radius: 50%;\n  ",
    "\n"])), function (_a) {
    var color = _a.color;
    return color !== null && color !== void 0 ? color : 'black';
}, function (_a) {
    var dotSize = _a.dotSize;
    switch (dotSize) {
        case 1:
            return 'height: 30px; width: 30px;';
        case 2:
            return 'height: 35px; width: 35px;';
        case 3:
            return 'height: 40px; width: 40px;';
        case 4:
            return 'height: 45px; width: 45px;';
        case 5:
            return 'height: 50px; width: 50px;';
        case 6:
            return 'height: 55px; width: 55px;';
        default:
            return 'height: 25px; width: 25px;';
    }
});
var Lines = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: auto;\n  margin-right: auto;\n  height: 100%;\n  /* CSS Trick for getting bigger dashes :-D */\n  /* lineSpacing > lineSize otherwise you get a stroke instead of a dash */\n  /* lineSize! means that there is no way that lineSize is undefined or null */\n  width: ", ";\n  background-image: ", ";\n  background-size: ", ";\n  background-position: ", ";\n  background-repeat: repeat-y;\n"], ["\n  margin-left: auto;\n  margin-right: auto;\n  height: 100%;\n  /* CSS Trick for getting bigger dashes :-D */\n  /* lineSpacing > lineSize otherwise you get a stroke instead of a dash */\n  /* lineSize! means that there is no way that lineSize is undefined or null */\n  width: ", ";\n  background-image: ",
    ";\n  background-size: ",
    ";\n  background-position: ", ";\n  background-repeat: repeat-y;\n"])), function (_a) {
    var lineWidth = _a.lineWidth;
    return (lineWidth ? lineWidth + "px" : '4px');
}, function (_a) {
    var color = _a.color, lineSize = _a.lineSize, lineSpacing = _a.lineSpacing;
    return "linear-gradient(" + color + " " + (lineSize / lineSpacing) * 100 + "%, rgba(255, 255, 255, 0) 0%)";
}, function (_a) {
    var lineSize = _a.lineSize, lineSpacing = _a.lineSpacing;
    return lineSize + "px " + lineSpacing + "px";
}, function (_a) {
    var position = _a.position;
    return position !== null && position !== void 0 ? position : 'left';
});
Lines.defaultProps = {
    lineWidth: 4,
    lineSize: 4,
    lineSpacing: 10,
    color: 'black'
};
var Dots = function (_a) {
    var color = _a.color, _b = _a.showLines, showLines = _b === void 0 ? true : _b, dotConfig = _a.dotConfig, lineConfig = _a.lineConfig;
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(Dot, __assign({ color: color }, dotConfig)),
        showLines && react_1.default.createElement(Lines, __assign({ color: color }, lineConfig))));
};
exports.default = Dots;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Dots.js.map